// extracted by mini-css-extract-plugin
module.exports = {"promotionalTilesComponent":"vV","promotionalTile":"vW","promotionalTileThumb":"vX","promotionalTileHeader":"vY","promotionalTileCaption":"vZ"};